import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import logo from "../Assets/logo.jpg";
import user_logo from "../Assets/user.png";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Home from "../Pages/Home";
import Customers from "../Pages/Customers";
import Cuts from "../Pages/Cuts";
import Settings from "../Pages/Settings";
import Users from "../Pages/Users";
import Logs from "../Pages/Logs";
import RemovedCustomers from "../Pages/RemovedCustomers";
import Schedule from "../Pages/Schedule";
import Booked from "./Booked";
import { ProgressBar } from "primereact/progressbar";
import { isAdmin } from "../Connection/Connection";
import MyCuts from "./MyCuts";

const MainLayout = ({ setIsAuthenticated }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isAdminMenu, setIsAdminMenu] = useState(false);
  const [activeLink, setActiveLink] = useState("");

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("user-data"));
    setUser(userData);
    setIsAdminMenu(isAdmin);
    setLoading(false);
  }, []);

  const logoutAlert = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      localStorage.clear();
      sessionStorage.clear();
      setIsAuthenticated(false);
    }
  };

  const renderAdminMenu = () => (
    <>
      <li className="nav-item">
        <Link
          to="/users"
          className={`nav-link ${activeLink === "users" ? "active" : ""}`}
          onClick={() => setActiveLink("users")}
        >
          <i className="nav-icon fas fa-users" />
          <p>Barbers</p>
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="/schedule"
          className={`nav-link ${activeLink === "schedule" ? "active" : ""}`}
          onClick={() => setActiveLink("schedule")}
        >
          <i className="nav-icon fas fa-calendar-check" />
          <p>Schedule</p>
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="/cuts"
          className={`nav-link ${activeLink === "cuts" ? "active" : ""}`}
          onClick={() => setActiveLink("cuts")}
        >
          <i className="nav-icon fas fa-cut" />
          <p>Cuts Price</p>
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="/logs"
          className={`nav-link ${activeLink === "logs" ? "active" : ""}`}
          onClick={() => setActiveLink("logs")}
        >
          <i className="nav-icon fas fa-history" />
          <p>History</p>
        </Link>
      </li>
    </>
  );

  return (
    <>
      <Header />
      {loading && (
        <div className="card">
          <ProgressBar mode="indeterminate" style={{ height: "3px" }} />
        </div>
      )}
      <Router>
        <aside className="main-sidebar sidebar-dark-primary elevation-4 sidebar-no-expand">
          <a href="" className="brand-link">
            <img
              src={logo}
              alt="AdminLTE Logo"
              className="brand-image img-circle elevation-3"
              style={{ opacity: ".8" }}
            />
            <span className="brand-text font-weight-light">Shawns Barber</span>
          </a>
          <div className="sidebar">
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="image">
                <img
                  src={user_logo}
                  className="img-circle elevation-2"
                  alt="User"
                />
              </div>
              <div className="info">
                <a href="/home" className="d-block">
                  {user?.name}
                </a>
              </div>
            </div>
            <div className="form-inline">
              <div className="input-group" data-widget="sidebar-search">
                <input
                  className="form-control form-control-sidebar"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
                <div className="input-group-append">
                  <button className="btn btn-sidebar">
                    <i className="fas fa-search fa-fw" />
                  </button>
                </div>
              </div>
            </div>
            <nav className="mt-2">
              {!loading && (
                <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  <li className="nav-item">
                    <Link
                      to="/home"
                      className={`nav-link ${
                        activeLink === "home" ? "active" : ""
                      }`}
                      onClick={() => setActiveLink("home")}
                    >
                      <i className="nav-icon fas fa-home" />
                      <p>Home</p>
                    </Link>
                  </li>{" "}
                  <li className="nav-item">
                    <Link
                      to="/myCuts"
                      className={`nav-link ${
                        activeLink === "myCuts" ? "active" : ""
                      }`}
                      onClick={() => setActiveLink("myCuts")}
                    >
                      <i className="nav-icon pi pi-users" />
                      <p>My Cuts</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/booked"
                      className={`nav-link ${
                        activeLink === "booked" ? "active" : ""
                      }`}
                      onClick={() => setActiveLink("booked")}
                    >
                      <i className="nav-icon fas fa-book" />
                      <p>Booked</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/customers"
                      className={`nav-link ${
                        activeLink === "customers" ? "active" : ""
                      }`}
                      onClick={() => setActiveLink("customers")}
                    >
                      <i className="nav-icon fas fa-users" />
                      <p>Customers</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/removedCustomers"
                      className={`nav-link ${
                        activeLink === "removedCustomers" ? "active" : ""
                      }`}
                      onClick={() => setActiveLink("removedCustomers")}
                    >
                      <i className="nav-icon fas fa-trash" />
                      <p>Removed Customers</p>
                    </Link>
                  </li>
                  {isAdminMenu && renderAdminMenu()}
                  <li className="nav-item">
                    <Link
                      to="/settings"
                      className={`nav-link ${
                        activeLink === "settings" ? "active" : ""
                      }`}
                      onClick={() => setActiveLink("settings")}
                    >
                      <i className="nav-icon fas fa-cog" />
                      <p>Settings</p>
                    </Link>
                  </li>
                  <li className="nav-item" style={{ cursor: "pointer" }}>
                    <span className="nav-link" onClick={logoutAlert}>
                      <i className="nav-icon fa fa-power-off" />
                      <p>Logout</p>
                    </span>
                  </li>
                </ul>
              )}
            </nav>
          </div>
        </aside>
        <Switch>
          <Route exact path="/home" component={Home} />
          <Route path="/cuts" component={Cuts} />
          <Route path="/customers" component={Customers} />
          <Route path="/settings" component={Settings} />
          <Route path="/users" component={Users} />
          <Route path="/logs" component={Logs} />
          <Route path="/removedCustomers" component={RemovedCustomers} />
          <Route path="/schedule" component={Schedule} />
          <Route path="/booked" component={Booked} />
          <Route path="/myCuts" component={MyCuts} />
        </Switch>
      </Router>
      <Footer />
    </>
  );
};

export default MainLayout;
